import ImageWithBasePath from "@/components/image-with-base-path";
import { Link } from "react-router";

const FaqSection = () => {
  return (
    <>
      {/* Start Faq */}
      <section className="faq-section-fourteen section">
        <div className="container">
          {/* start row */}
          <div className="row">
            <div className="col-lg-6">
              <div className="section-header section-header-fourteen">
                <h2 className="section-title">
                  Most <span className="section-line">Dermatology</span>{" "}
                  <span className="subtitle">Questions?</span>
                </h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="faq-info faq-info-fourteen wow zoomIn"
                data-wow-duration="1s"
              >
                <div className="accordion" id="faq-details-one">
                  {/* FAQ Item */}
                  <div className="accordion-item active">
                    <h3 className="accordion-header" id="headingOne">
                      <Link
                        to="#"
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        How do I know which skincare treatment is right for me?
                      </Link>
                    </h3>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#faq-details-one"
                    >
                      <div className="accordion-body">
                        <div className="accordion-content">
                          <p>
                            Our skincare specialists analyze your skin type,
                            concerns, and goals before recommending the most
                            suitable treatment for safe and effective results.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /FAQ Item */}
                  {/* FAQ Item */}
                  <div className="accordion-item">
                    <h3 className="accordion-header" id="headingTwo">
                      <Link
                        to="#"
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Are skincare treatments safe for sensitive skin?
                      </Link>
                    </h3>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#faq-details-one"
                    >
                      <div className="accordion-body">
                        <div className="accordion-content">
                          <p>
                            Yes, we offer customized treatments specially
                            designed for sensitive skin using gentle,
                            dermatologist-approved products and techniques.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /FAQ Item */}
                  {/* FAQ Item */}
                  <div className="accordion-item">
                    <h3 className="accordion-header" id="headingThree">
                      <Link
                        to="#"
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        How many sessions are needed to see results?
                      </Link>
                    </h3>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#faq-details-one"
                    >
                      <div className="accordion-body">
                        <div className="accordion-content">
                          <p>
                            Results vary depending on the treatment and skin
                            condition. Some treatments show immediate results,
                            while others may require multiple sessions.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /FAQ Item */}
                  {/* FAQ Item */}
                  <div className="accordion-item">
                    <h3 className="accordion-header" id="headingFour">
                      <Link
                        to="#"
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Do I need a consultation before booking a treatment?
                      </Link>
                    </h3>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      data-bs-parent="#faq-details-one"
                    >
                      <div className="accordion-body">
                        <div className="accordion-content">
                          <p>
                            Yes, we recommend a consultation to understand your
                            skin concerns and create a personalized treatment
                            plan.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /FAQ Item */}
                  {/* FAQ Item */}
                  <div className="accordion-item">
                    <h3 className="accordion-header" id="headingFive">
                      <Link
                        to="#"
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        Are your skincare specialists certified professionals?
                      </Link>
                    </h3>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      data-bs-parent="#faq-details-one"
                    >
                      <div className="accordion-body">
                        <div className="accordion-content">
                          <p>
                            Yes, all our skincare specialists are trained,
                            experienced, and certified to provide safe and
                            professional skincare treatments.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /FAQ Item */}
                  {/* FAQ Item */}
                  <div className="accordion-item">
                    <h3 className="accordion-header" id="headingSix">
                      <Link
                        to="#"
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        Is there any downtime after skincare treatments?
                      </Link>
                    </h3>
                    <div
                      id="collapseSix"
                      className="accordion-collapse collapse"
                      data-bs-parent="#faq-details-one"
                    >
                      <div className="accordion-body">
                        <div className="accordion-content">
                          <p>
                            Most treatments have minimal or no downtime.
                            However, some advanced treatments may require short
                            recovery periods.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /FAQ Item */}
                </div>
              </div>
            </div>
          </div>
          {/* end row */}
        </div>
        <ImageWithBasePath
          src="assets/img/bg/faq-bg-02.png"
          alt="bg"
          className="faq-bg img-fluid"
        />
      </section>
      {/* End Faq */}
    </>
  );
};

export default FaqSection;
